const _require = require('@truqc/content-path'),
  parsePath = _require.parsePath;

/**
  * @function evalute - evaluate parentPathComponentsBehavior
  */

const evaluate = async (source, content, parentContentPath) => parsePath(parentContentPath);
module.exports = {
  evaluate
};